import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router, ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {AuthorizationService} from '../../shared/authorization.service';
import {KeyValue} from '../../shared/key-value';

@Component({
  selector: 'change-password-submit',
  templateUrl: 'change-password-submit.component.html'
})
export class ChangePasswordSubmitComponent {
   user_email: any;
   enableLink:any;
   enableLayoutMenu:boolean = false;
  constructor(private router: Router, private _tokenService: AngularTokenService,
  public authService: AuthorizationService, private route: ActivatedRoute) {
    this.user_email=this._tokenService.currentUserData.uid;
    this.enableLink = this.authService.getCRole();
  }
  Sigin(event): void {
    //event.preventDefault();
    console.log('inside signout course');
    this._tokenService.signOut().subscribe(
      res => {
        this.router.navigate(['/sign-in']);
      },
        error =>    console.log(error)
    );
  }
  ngOnInit() {

  }

  AdminHome(){
    this.router.navigate(['/admin']);
  }
  InstructorHome(){
    this.router.navigate(['/instructor']);
  }
  InstructorAdminHome(){
    this.router.navigate(['/instructor-admin']);
  }
  StudentHome(){
    this.router.navigate(['/student']);
  }

}
